<template lang="pug">
  div.cuadro
    //- div.icono-container
      span.icono
        i.fa(:class="iconClass")
    div.cuadro-content
      div.cuadro-title {{ title }}
      div.cuadro-number {{ number }}
</template>

<script>
export default {
  name: 'Infocuadro',
  props: {
    title: {
      type: String,
      required: true
    },
    number: {
      type: [String, Number],
      required: true
    },
    iconClass: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="stylus" scoped>
.cuadro
  background-color #fff
  padding 20px
  padding-left 10px
  padding-right 10px
  border-radius 8px
  box-shadow 0 2px 4px rgba(0, 0, 0, 0.1)
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 150px
  height 150px
  position relative // Añadido para que el ícono se posicione correctamente dentro de la tarjeta

.cuadro-title
  font-size 16px
  font-weight bold

.cuadro-number
  font-size 32px
  font-weight bold
  color #565cde

.icono-container
  position absolute
  top 10px
  right 10px

.icono
  font-size 24px
  color #ffa500
</style>



// WEBPACK FOOTER //
// c_info_card.vue?7c4cdba2